import styled from 'styled-components';
import { theme } from 'styles';

export const AttachmentPreview = styled.div`
  margin-right: 15px;
  padding: 0 8px 0 8px;
  border: dashed 1px ${theme.color.grey75};
`;
